import { message, Descriptions, Button, Splitter } from 'antd'
import { useCallback, useState } from 'react'
import { createUseStyles } from 'react-jss'
import { useNavigate, useParams } from 'react-router-dom'
import api from '../../api'
import { PageHeader } from '../Common'
import PDFPreview from '../Common/PDFPreview'
import { useAsync } from '../../hooks'
import Loading from '../Loading'
import TransmissionSidebar from '../Common/TransmissionSidebar'
import AlertForm from './AlertForm'
import { useSidebar } from '../Layout/SidebarContext'

const useStyles = createUseStyles({
  app: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    flex: '1 1 auto',
  },
  pdfBox: {
    maxWidth: 'calc(100% - 456px)',
    flexGrow: '1',
    minWidth: '100%',
    position: 'relative',
    height: 'calc(100vh - 96px - 68px)',
    overflowY: 'scroll',
    overflowX: 'hidden',
    '& canvas': {
      maxWidth: '100%',
    },
  },
  formBox: {
    position: 'relative',
    overflowY: 'scroll',
    height: 'calc(100vh - 96px - 68px)',
    padding: '0 16px',
    '& > form': {
      marginTop: '-16px',
    },
  },
  patientContainer: {
    padding: '0 16px',
   },
})

export default function Edit() {
  const { id } = useParams()
  const classes = useStyles()
  const navigate = useNavigate()
  const getAlert = useCallback(
    () => api.alerts.get(id, { includeForm: true }),
    [id],
  )
  const { pending, value: alert } = useAsync(getAlert)
  const [isPatientDrawerVisible, setIsPatientDrawerVisible] = useState(false)
  const { setIsSidebarVisible, isSidebarVisible } = useSidebar()

  const togglePatientDrawer = () => {
    if (!isPatientDrawerVisible && isSidebarVisible) {
      setIsSidebarVisible(false)
    } else if (isPatientDrawerVisible && !isSidebarVisible) {
      setIsSidebarVisible(true)
    }
    setIsPatientDrawerVisible(!isPatientDrawerVisible)
  }


  const onSubmit = useCallback(
    async values => {
      try {
        await api.alerts.update(id, values)
        message.success('Alert successfully updated')
        navigate(-1)
      } catch (e) {
        message.error('Oops, we had a problem. Please try submitting again')
      }
    },
    [navigate, id],
  )

  if (pending) return <Loading large />

  return (
    <div className={classes.app}>
      <PageHeader
        title="Edit Alert"
        onBack={() => navigate(-1)}
        extra={<Button onClick={togglePatientDrawer}>{isPatientDrawerVisible ? 'Hide' : 'Show'} Patient</Button>}
      />
      <Splitter>
        <Splitter.Panel>
          <div className={classes.pdfBox}>
            <PDFPreview path={alert.rawFilePath} perPage={10} />
          </div>
        </Splitter.Panel>
        <Splitter.Panel size={300}>
          <div className={classes.formBox}>
            <AlertForm
              form={{ ...alert.form, critical: alert.critical }}
              onSubmit={onSubmit}
            />
          </div>
        </Splitter.Panel>
        <Splitter.Panel size={isPatientDrawerVisible ? 300 : 0} resizable={false}>
          <div className={classes.patientContainer}>
            <h3>Patient Information</h3>
            <Descriptions column={1} size="small" layout="vertical">
              <Descriptions.Item label="Device Type">
                {alert.device.deviceModel.deviceType.name}
              </Descriptions.Item>
              <Descriptions.Item label="Device Serial Number">
                {alert.device.serialNumber}
              </Descriptions.Item>
            </Descriptions>
            <TransmissionSidebar
              patient={alert.patient}
              practiceId={alert.patient.practiceId}
            />
          </div>
        </Splitter.Panel>
      </Splitter>
    </div>
  )
}
